/*
 * Pretty printer used to print values in repl.js.
 */

const pretty = (value: unknown): string => {
  if (value === null || value === undefined) {
    return String(value);
  }

  switch ((value as { constructor: { name: string } }).constructor.name) {
    case 'Boolean':
    case 'Function':
    case 'Number':
      return String(value);

    case 'Array':
      return prettyArray(value as unknown[]);

    case 'Object':
      return prettyObject(value as object);

    case 'String':
      return prettyString(value as string);

    default:
      return prettyInstance(value);
  }
};

const prettyArray = (a: unknown[]): string => {
  return `[${a.map(pretty).join(', ')}]`;
};

const prettyObject = (o: object): string => {
  const pair = ([k, v]: [string, unknown]) => `${asName(k)}: ${pretty(v)}`;

  return `{ ${Object.entries(o).map(pair).join(', ')} }`;
};

const prettyString = (s: string): string => {
  return `'${[...s].map((cp) => maybeEscape(cp)).join('')}'`;
};

const prettyInstance = (i: unknown): string => {
  //return `${i.constructor.name} ${prettyObject(i)}`;
  return String(i); // this seems better? At least it handles things like Date objects
};

const maybeEscape = (c: string): string => {
  switch (c) {
    case "'":
      return "\\'";
    case '\\':
      return '\\\\';
    case '\b':
      return '\\b';
    case '\f':
      return '\\f';
    case '\n':
      return '\\n';
    case '\r':
      return '\\r';
    case '\t':
      return '\\t';
    case '\v':
      return '\\v';
    default:
      return c;
  }
};

const asName = (n: string): string => (n.match(/^\w+$/) ? n : prettyString(n));

export default pretty;
